import { useQuery } from "@tanstack/react-query"
import { gorgiasIntegrationQuery } from "modules/settings/lib/gorgias/gorgiasIntegrationQuery"

export function useGorgiasIntegrationQuery(...args: Parameters<typeof gorgiasIntegrationQuery>) {
  return useQuery(gorgiasIntegrationQuery(...args))
}
